module.exports = __webpack_public_path__ + "static/img/bg-fr.a0a6a3ed.webp";